
import { defineComponent } from "vue";
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import { userService } from "./services/user.service";
import { userStore } from "./store";
import "@/assets/css/main.css";

export default defineComponent({
  components: { AppHeader, AppFooter },
  name: "App",
  setup() {
    document.title = "MonkeyBattle";
    if (!userStore.getters.isAuthenticated()) {
      userService.setStoreUser();
    }
  },
});
